import { Facebook, Ghost, Globe, Instagram, MessageCircle, Send, Youtube } from "lucide-react";

export const ICON_OPTS = ["facebook", "instagram", "tiktok", "snapchat", "youtube", "whatsapp", "telegram", "x", "globe"];

export const SocialIcon = ({ id, className = "h-4 w-4" }) => {
  if (id === "facebook") return <Facebook className={className} />;
  if (id === "instagram") return <Instagram className={className} />;
  if (id === "tiktok")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.25-.02-.5-.03-.76.01-.04.53-.07.53-.11 1.74.72 3.7 1.03 5.54.15 1.87-.79 3.28-2.53 3.7-4.53.09-.44.13-.89.13-1.34V.02z" />
      </svg>
    );
  if (id === "snapchat") return <Ghost className={className} />;
  if (id === "youtube") return <Youtube className={className} />;
  if (id === "whatsapp") return <MessageCircle className={className} />;
  if (id === "telegram") return <Send className={className} />;
  if (id === "x")
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
        <path d="M4 4l16 16M20 4L4 20" />
      </svg>
    );
  return <Globe className={className} />;
};
